<div class="ts-progress">
    <h4 class="ts-progress-label">{{label}}</h4>
    <span class="ts-progress-bar"></span>
    <span class="ts-progress-complete" [style.width.%]="completed"></span>
    <p class="ts-progress-description">{{description}}</p>
</div>